'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _blocks = require('../../blocks');

var _elements = require('../../elements');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputText = function (_Component) {
  _inherits(InputText, _Component);

  function InputText() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputText.__proto__ || Object.getPrototypeOf(InputText)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focus: false
    }, _this.handleBlur = function (e) {
      _this.props.onBlur(e);
      return _this.setState({ focus: false });
    }, _this.handleFocus = function (e) {
      _this.props.onFocus(e);
      return _this.setState({ focus: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputText, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // eslint-disable-next-line no-console
      console.error('\n      \uD83D\uDEA8 DEPRECATION WARNING: InputText will soon be deprecated. Please use InputField instead.\n    ');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          isValid = _props.isValid,
          label = _props.label,
          name = _props.name,
          onChange = _props.onChange,
          placeholder = _props.placeholder,
          value = _props.value;
      var focus = this.state.focus;

      var borderFocus = focus && 'borderChrome600';
      var borderWarning = !isValid && 'borderWarning';
      var disabledInput = disabled && 'disabled';
      var borderModifiers = (0, _lodash.compact)([borderFocus, borderWarning, disabledInput, 'column', 'pad']);

      return _react2.default.createElement(
        _blocks.Input,
        { modifiers: borderModifiers },
        _react2.default.createElement(
          _elements.Label,
          { modifiers: ['gapX'] },
          label
        ),
        _react2.default.createElement(_elements.TextField, {
          isValid: isValid,
          modifiers: ['gapX'],
          name: name,
          onBlur: this.handleBlur,
          onChange: onChange,
          onFocus: this.handleFocus,
          placeholder: placeholder,
          type: 'text',
          value: value,
          disabled: disabled
        })
      );
    }
  }]);

  return InputText;
}(_react.Component);

InputText.propTypes = {
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string.isRequired
};

InputText.defaultProps = {
  disabled: false,
  isValid: true,
  label: '',
  onBlur: _lodash.noop,
  onChange: _lodash.noop,
  onFocus: _lodash.noop,
  placeholder: 'Enter Value...'
};

exports.default = InputText;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/InputText/index.js
// module id = 1667
// module chunks = 2